import { MediaInfo, MediaItem, MediaSegment } from "../../../../domain/media";
import { PriorityLevelViewModel } from "./priotiry-level/priority-level.view-model";
import {
  ETranscodingJobPriority,
  ETranscodingJobStatus,
  TranscoderJobDetails,
} from "../../../../domain/media-transcoder/transcoder-job";

import { MediaTranscodingItem } from "../../../../domain/media-transcoder/media-transcoding-item";
import { NgxSmartModalService } from "ngx-smart-modal";
import { MediaRepository } from "../../../../domain/media-repository";
import { ELayoutZoneType } from "../../../../domain/layouts/layoutZone";
import { LayoutZoneViewModel } from "../../../layouts/view-models/layout.view-model";
import { ChangeDetectorRef } from "@angular/core";
import { UserService } from "app/js/src/domain/user-service";

export class JobSettingsViewModel {
  public jobName: string;
  public jobId: string;
  public selectedMediaItem: MediaItemTranscodeSettingVM;
  public selectedMediaInfo: Promise<MediaInfo>;
  public selectedPriorityLevelId: number;
  public selectedStatus: ETranscodingJobStatus;
  public editMode = false;
  showRedBorderOnMediaFilesLandzone = false;

  private _currentJobDetails: TranscoderJobDetails;
  onMediaFilesDrag = false;
  executeOnlySideEffects = false;
  selectedTranscodingDestination = -1;
  selectedTranscodingProfile = -1;
  selectedTranscodingSideEffect = -1;
  selectedProfileType: "regular" | "clustered" = "regular";
  allTranscodingSideEffects: SideEffectViewModel[] = [];
  allTranscodingDestinations: MediaTranscoderDestinationViewModel[] = [];
  standaloneTranscodingProfiles: TranscodingProfileViewModel[] = [];
  clusteredTranscodingProfiles: TranscodingProfileViewModel[] = [];
  allPriorities: PriorityLevelViewModel[] = [];

  selectedItemPreviewUrl: Promise<string>;
  public mediaItemsToTranscode: MediaItemTranscodeSettingVM[] = [];
  public manualMediaIdsInput: string = "";
  public selectedMediaInputTab: "drag" | "manual" = "drag";
  public isSuperUser: boolean = false;
  constructor(
    public headerTitle: string,
    private _userService: UserService,
    private _toaster: IToasterProxy,
    private _router: IRouterProxy,
    private _mediaProxy: IMediaProxy,
    private _transcodingJobRepositoryProxy: ITranscodingJobRepositoryProxy,
    private _ngxSmartModalService: NgxSmartModalService,
    private _mediaRepository: MediaRepository,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {}

  public async initFields() {
    this.allTranscodingDestinations =
      await this._transcodingJobRepositoryProxy.getDestinations();

    const profiles = await this._transcodingJobRepositoryProxy.getProfiles();

    this.allTranscodingSideEffects =
      await this._transcodingJobRepositoryProxy.getSideEffects();

    this.standaloneTranscodingProfiles = profiles.filter(
      (p) => p.isClustered === false,
    );
    this.clusteredTranscodingProfiles = profiles.filter(
      (p) => p.isClustered === true,
    );
    this.initPriorities();
    this.isSuperUser = await this._userService.getCurrentUser().isSuperUser;
  }

  public lodJobDetails(jobDetails: TranscoderJobDetails) {
    this.jobName = jobDetails.name;
    this.jobId = jobDetails.id;
    this.selectedTranscodingDestination = jobDetails.destinationId;
    this.selectedTranscodingProfile = jobDetails.transcodingProfileId;
    this.selectedTranscodingSideEffect = -1;
    this.selectedPriorityLevelId = jobDetails.priority;
    this.selectedStatus = jobDetails.status;
    // tslint:disable-next-line:max-line-length
    this.mediaItemsToTranscode = jobDetails.transcodingItems
      .map((item) => item as MediaTranscodingItem)
      .map(
        (transcodingItem) =>
          new MediaItemTranscodeSettingVM(
            transcodingItem.mediaId,
            transcodingItem.videoTitle,
            transcodingItem.videoTenantUniqueId,
            transcodingItem.videoDurationMs,
            transcodingItem.startTimeMs,
            transcodingItem.endTimeMs,
          ),
      );
    this._currentJobDetails = jobDetails;
    console.log("media-transcoder-> lodJobDetails->finished");
  }

  private initPriorities() {
    this.allPriorities = [];
    const balance = 5;
    this.allPriorities.push(
      new PriorityLevelViewModel(
        0,
        "Low",
        "#4472C1",
        balance,
        1,
        "16:30 06/30/2020",
      ),
    );
    this.allPriorities.push(
      new PriorityLevelViewModel(
        1,
        "Medium",
        "#F5D7AC",
        balance,
        2,
        "16:30 03/30/2020",
      ),
    );
    this.allPriorities.push(
      new PriorityLevelViewModel(
        2,
        "High",
        "#C49C9E",
        balance,
        10,
        "16:30 01/30/2020",
      ),
    );
  }

  async applyClicked($event: MouseEvent) {
    //this._toaster.showInfo('Saving...');
    if (this._verifyFields()) {
      try {
        // Parse manual media IDs if no media items are present
        if (
          this.mediaItemsToTranscode.length === 0 &&
          this.manualMediaIdsInput.trim()
        ) {
          this._parseManualMediaIds();
        }

        if (this.editMode) {
          if (
            this.selectedPriorityLevelId !== this._currentJobDetails.priority
          ) {
            await this._transcodingJobRepositoryProxy.changeJobPriority(
              this.jobId,
              this.selectedPriorityLevelId,
            );
            this._toaster.showSuccess("Successfully updated the job!");
          }
        } else {
          await this._transcodingJobRepositoryProxy.createNewTranscodingJob(
            this,
          );
          this._toaster.showSuccess("Successfully created a new job!");
        }

        this.closeWindowAndGoBack();
      } catch (e) {
        this._toaster.showError(e);
      }
    }
  }

  removeItem(item: MediaItemTranscodeSettingVM) {
    const itemIndex = this.mediaItemsToTranscode.findIndex((i) => i === item);
    if (this.selectedMediaItem === item) {
      this.selectedMediaItem = null;
    }
    this.mediaItemsToTranscode.splice(itemIndex, 1);

    this._verifyFields();
  }

  selectItemForTrimming(item: MediaItemTranscodeSettingVM) {
    this.selectedMediaItem =
      this.selectedMediaInfo =
      this.selectedItemPreviewUrl =
        null;

    this.selectedMediaInfo = this._mediaProxy.getMediaInfoByMediaId(
      item.mediaId,
    );
    this.selectedItemPreviewUrl = this._mediaProxy.getPreviewUrl(item.mediaId);
    this.selectedMediaItem = item;
  }

  onMediaFilesDragEnter() {
    if (this.onMediaFilesDrag === false) {
      this.onMediaFilesDrag = true;
    }
  }

  onMediaFilesDragLeave() {
    if (this.onMediaFilesDrag) {
      this.onMediaFilesDrag = false;
    }
  }

  async onMediaFilesDrop(dragEvent: DragEvent) {
    this.onMediaFilesDrag = false;
    const data = dragEvent.dataTransfer.getData("text/media");
    if (data && this.editMode === false) {
      const selectedMedia: MediaItem = JSON.parse(data);
      const mediaInfo = await this._mediaRepository.getMediaInfo(
        selectedMedia.id,
      );
      console.log(
        "job-settings-vm-> onMediaFilesDrop-> media item info",
        mediaInfo,
      );
      if (mediaInfo && mediaInfo.segments.length > 0) {
        await this._mediaItemWithSegmentsDraggedEventHandler(mediaInfo);
      } else {
        this.mediaItemsToTranscode.push(
          MediaItemTranscodeSettingVM.fromMediaItem(selectedMedia),
        );
      }
    }
    this._changeDetectorRef.markForCheck();
    this._changeDetectorRef.detectChanges();
    this._verifyFields();
  }

  selectPriority(priority: PriorityLevelViewModel) {
    if (priority.available) {
      this.selectedPriorityLevelId = priority.id;
    } else {
      this._toaster.showError("You don't have enough credits");
    }
  }

  selectProfileType(profileType: "regular" | "clustered") {
    this.selectedProfileType = profileType;
    // Reset selected profile when switching types
    this.selectedTranscodingProfile = -1;
  }

  selectMediaInputTab(tab: "drag" | "manual") {
    this.selectedMediaInputTab = tab;
  }

  closeWindowAndGoBack() {
    //this._router.navigateTo('../', true);
    this._router.locationBack();
  }

  private async _mediaItemWithSegmentsDraggedEventHandler(media: MediaInfo) {
    this._ngxSmartModalService.setModalData(
      {
        mediaId: media.id,
        onSegmentsSelectedCallback: (segments: MediaSegment[]) => {
          if (segments && segments.length > 0) {
            for (const chosenSegment of segments) {
              this.mediaItemsToTranscode.push(
                MediaItemTranscodeSettingVM.fromMediaSegment(chosenSegment),
              );
            }
          }
        },
        currentChannel: null,
        allowMultiSelect: true,
        onDataBindEnded: () => {
          this._changeDetectorRef.markForCheck();
          this._changeDetectorRef.detectChanges();
        },
      },
      "chooseSegmentModal",
      true,
    );
    this._ngxSmartModalService.getModal("chooseSegmentModal").open();
  }

  async abortJobClicked($event: MouseEvent) {
    //this._toaster.showInfo('Saving...');
    if (
      await this._toaster.confirm("Are you sure you want to abort this job?")
    ) {
      try {
        await this._transcodingJobRepositoryProxy.abortTranscodingJob(
          this.jobId,
        );
        this._toaster.showSuccess("Successfully aborted the job!");
        this.closeWindowAndGoBack();
      } catch (e) {
        this._toaster.showError(e);
      }
    }
  }

  private _verifyFields(): boolean {
    this.showRedBorderOnMediaFilesLandzone =
      this.mediaItemsToTranscode.length === 0;

    // Check if we have media items or manual media IDs input
    const hasMediaItems = this.mediaItemsToTranscode.length > 0;
    const hasManualMediaIds = this.manualMediaIdsInput.trim().length > 0;

    return hasMediaItems || hasManualMediaIds;
  }

  private _parseManualMediaIds(): void {
    const mediaIdLines = this.manualMediaIdsInput
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    for (const mediaIdStr of mediaIdLines) {
      const mediaId = parseInt(mediaIdStr, 10);
      if (!isNaN(mediaId) && mediaId > 0) {
        // Create a fake MediaItemTranscodeSettingVM with only the media ID
        const fakeMediaItem = new MediaItemTranscodeSettingVM(
          mediaId,
          `Media ID: ${mediaId}`, // Placeholder title
          `tenant_${mediaId}`, // Placeholder tenant ID
          0, // Duration will be set by the API
          0, // mediaIn
          0, // mediaOut
        );
        this.mediaItemsToTranscode.push(fakeMediaItem);
      }
    }
  }
}

export class MediaItemTranscodeSettingVM {
  public static fromMediaItem(
    mediaItem: MediaItem,
  ): MediaItemTranscodeSettingVM {
    return new MediaItemTranscodeSettingVM(
      mediaItem.id,
      mediaItem.name,
      mediaItem.tenantMediaId,
      mediaItem.contentMediaDurationMs,
      0,
      mediaItem.contentMediaDurationMs,
    );
  }

  public static fromMediaSegment(
    mediaSegment: MediaSegment,
  ): MediaItemTranscodeSettingVM {
    return new MediaItemTranscodeSettingVM(
      mediaSegment.parentMedia.id,
      mediaSegment.parentMedia.name + `, Segment: ${mediaSegment.description}`,
      mediaSegment.parentMedia.tenantMediaId,
      mediaSegment.parentMedia.contentMediaDurationMs,
      mediaSegment.timeInMs,
      mediaSegment.timeOutMs,
    );
  }

  public get trimmed(): boolean {
    return this.mediaIn !== 0 || this.mediaOut !== this.durationMs;
  }
  constructor(
    public mediaId: number,
    public videoTitle: string,
    public videoId: string,
    public durationMs: number,
    public mediaIn: number,
    public mediaOut: number,
  ) {}

  public resetTrimming() {
    this.mediaIn = 0;
    this.mediaOut = this.durationMs;
  }
}

export class MediaTranscoderDestinationViewModel {
  constructor(
    public id: number,
    public title: string,
    public selectedByDefault: boolean,
  ) {}
}

export class TranscodingProfileViewModel {
  constructor(
    public id: number,
    public title: string,
    public isClustered: boolean = false,
  ) {}
}

export class SideEffectViewModel {
  constructor(
    public id: number,
    public title: string,
    public isClustered: boolean = false,
  ) {}
}
export interface IToasterProxy {
  showError(msg: string);
  showInfo(msg: string);
  showSuccess(msg: string);
  confirm(msg: string): Promise<boolean>;
}

export interface IRouterProxy {
  navigateTo(path: string, isRelativeToCurrentRoute: boolean);
  locationBack();
}

export interface ITranscodingJobRepositoryProxy {
  getProfiles(): Promise<TranscodingProfileViewModel[]>;
  getDestinations(): Promise<MediaTranscoderDestinationViewModel[]>;
  getSideEffects(): Promise<SideEffectViewModel[]>;
  createNewTranscodingJob(job: JobSettingsViewModel): Promise<void>;
  abortTranscodingJob(jobId: string): Promise<void>;
  changeJobPriority(
    jobId: string,
    newPriority: ETranscodingJobPriority,
  ): Promise<void>;
}

export interface IMediaProxy {
  getMediaInfoByMediaId(mediaId: number): Promise<MediaInfo>;
  getPreviewUrl(mediaId: number): Promise<string>;
}
